import React from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";

const BatterSide = styled.button.attrs({
  className: "btn"
})`
  border: solid 1px #d2d2d2 !important;
  font-size: 11px !important;
  font-weight: bold !important;
  letter-spacing: -0.4px !important;
  max-height: 22px !important;
  min-height: 22px !important;
  max-width: ${props => props.width + "px"};
  min-width: ${props => props.width + "px"};
  padding: 0 !important;
  ${props => (props.selected ? "background-color: #fdec98 !important;" : "")};
`;

class GameViewerFilterBatterSide extends React.Component {
  onChange(value) {
    if (!this.props.selected) {
      const gameViewerStore = this.props.rootStore.gameViewerStore;
      gameViewerStore.setHandFilter(this.props.value);
    }
  }

  render() {
    const { label, rootStore, width, value } = this.props;
    const gameViewerStore = rootStore.gameViewerStore;
    const { handFilter, selectedPitch } = gameViewerStore;
    const selected = handFilter === value;
    return (
      <BatterSide disabled={selectedPitch} onClick={this.onChange.bind(this)} selected={selected} width={width}>
        {label}
      </BatterSide>
    );
  }
}

export default inject("rootStore")(observer(GameViewerFilterBatterSide));
